import type { api } from "~/utils/api";

type InboxUtils = ReturnType<typeof api.useUtils>;

export const invalidateInbox = (utils: InboxUtils): void => {
  void utils.communication.inboxSearch.invalidate();
  void utils.communication.inboxCount.invalidate();
  void utils.communication.inboxCounts.invalidate();
};
